import { render, staticRenderFns } from "./BaseFormGroupInputPassword.vue?vue&type=template&id=2127af40"
import script from "./BaseFormGroupInputPassword.vue?vue&type=script&lang=js"
export * from "./BaseFormGroupInputPassword.vue?vue&type=script&lang=js"
import style0 from "./BaseFormGroupInputPassword.vue?vue&type=style&index=0&id=2127af40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports